// What the user typed into the server-rendered fallback, captured just before Vue's mount wipes it.
export interface StaticSignupFormValues {
  firstName: string
  lastName: string
  email: string
  password: string
  focusedId: string | null
}

let captured: StaticSignupFormValues | null = null

export function captureStaticSignupForm() {
  const form = document.querySelector('#app #signup-form-form')
  if (!(form instanceof HTMLFormElement)) return

  const read = (id: string) => {
    const input = form.querySelector(`#${id}`)
    return input instanceof HTMLInputElement ? input.value : ''
  }
  const active = document.activeElement
  captured = {
    firstName: read('first-name'),
    lastName: read('last-name'),
    email: read('email'),
    password: read('password'),
    focusedId:
      active instanceof HTMLInputElement && form.contains(active)
        ? active.id
        : null,
  }
}

export function takeStaticSignupForm(): StaticSignupFormValues | null {
  const values = captured
  captured = null
  return values
}
